import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dccdfecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalContainer" }
const _hoisted_2 = { class: "modalContainer__inner" }
const _hoisted_3 = { class: "modalContainer__content" }
const _hoisted_4 = { class: "modalContainer__closeSection" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modalContainer__contentSection" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "modalContainer__closeSection--button"
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.open]
  ])
}